import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { THEME_LOOKUPS_RESOURCE, CREATE_THEME_LOOKUP_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const CreateThemeLookupService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_THEME_LOOKUP_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.themeLookups(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: THEME_LOOKUPS_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createThemeLookupFailed'),
            onSuccessMessage: t('createThemeLookupSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateThemeLookupService;
